import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';
import axios from "axios";
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';

const AnnualStatements = () => {
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [balanceData, setBalanceData] = useState([]);
    const [openingBalance, setOpeningBalance] = useState(0);
    const [totalDebit, setTotalDebit] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);

    // Fetch client list from the API
    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get("https://react-apis.dotlocalhost.com/showClientsAnnual.php");
                if (Array.isArray(response.data)) {
                    setClients(response.data);
                } else {
                    console.error('API response is not an array:', response.data);
                }
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };

        fetchClients();
    }, []);

    // Fetch annual statement data based on selected client and year
    useEffect(() => {
        const fetchAnnualStatementData = async () => {
            if (selectedClient && selectedYear) {
                try {
                    const response = await axios.get(`https://react-apis.dotlocalhost.com/showClientAnnualData.php?clid=${selectedClient}&year=${selectedYear}`);
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        setOpeningBalance(parseFloat(response.data[0].balance) || 0);
                        calculateBalance(response.data);
                    } else {
                        setBalanceData([]);
                    }
                } catch (error) {
                    console.error("Error fetching annual statement data:", error);
                }
            }
        };
        fetchAnnualStatementData();
    }, [selectedClient, selectedYear]);

    // sidebar background color set
    useEffect(() => {
        const sidebarItemmain = document.getElementById("accnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9";
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("anlstm");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7";
            sidebarItem.style.color = "#000000";
        }

        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = "";
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = "";
                sidebarItem.style.color = "#000000";
            }
        };

    }, []);

    const calculateBalance = (data) => {
        let balance = parseFloat(data[0].balance) || 0;
        let totalDebitAmount = 0;
        let totalCreditAmount = 0;

        const calculatedData = data.map((row, index) => {
            if (index === 0) return { ...row, balance: balance.toFixed(2) };

            const debit = parseFloat(row.debit) || 0;
            const credit = parseFloat(row.credit) || 0;

            totalDebitAmount += debit;
            totalCreditAmount += credit;

            balance = balance + debit - credit;
            return { ...row, balance: balance.toFixed(2) };
        });

        setTotalDebit(totalDebitAmount.toFixed(2));
        setTotalCredit(totalCreditAmount.toFixed(2));
        setBalanceData(calculatedData);
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='innerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>View Annual Statements</h3>
                        </div>
                    </div>

                    <div className='row mb-5'>
                        <div className='col-3'>
                            <label className="form-label"><b>Client Name</b></label>
                            <select className='form-control' value={selectedClient} onChange={(e) => setSelectedClient(e.target.value)} >
                                <option value="">-- Select Client --</option>
                                {clients.map((client) => (
                                    <option key={client.clid} value={client.clid}>
                                        {client.clientName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='col-3'>
                            <label className="form-label"><b>Select Year</b></label>
                            <select className='form-control' value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} >
                                <option value="">-- Select Year --</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                            </select>
                        </div>
                    </div>

                    {balanceData.length > 0 ? (
                        <Table striped bordered hover style={{ fontSize: '12px' }}>
                            <thead>
                                <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                    <th>Date</th>
                                    <th>Particulars</th>
                                    <th>Debit</th>
                                    <th>Credit</th>
                                    <th>Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {balanceData.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.date}</td>
                                        <td>{row.particulars}</td>
                                        <td>{row.debit}</td>
                                        <td>{row.credit}</td>
                                        <td>{row.balance}</td>
                                    </tr>
                                ))}
                                {/* Add totals row */}
                                <tr style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }}>
                                    <td colSpan="2">Total</td>
                                    <td>{totalDebit}</td>
                                    <td>{totalCredit}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    ) : (
                        <p>No annual statement data available for this client.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnnualStatements;
